/**
 * Contact popup + scoped contact forms (CF7) initializer
 *
 * Handles:
 * - Opening/closing a modal popup with the same contact UI
 * - Initializing the contact toggle (sales/partner) inside each scope independently
 * - Enabling submit only when all `.contact__checkbox` are checked (per form)
 * - Initializing custom file input UI inside each scope
 *
 * @package KateMedia
 */
 
function initContactScope(scope) {
  if (!scope) return;

  const radioBtns = scope.querySelectorAll('.contact__radio');
  const salesForm = scope.querySelector('.contact__form--sales');
  const partnerForm = scope.querySelector('.contact__form--partner');

  if (!salesForm || !partnerForm || radioBtns.length === 0) return;

  // Initially hide partner form
  partnerForm.style.display = 'none';

  function checkCheckboxes(form) {
    if (!form) return;
    const checkboxes = form.querySelectorAll('.contact__checkbox');
    const submitBtn =
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]');

    if (checkboxes.length > 0 && submitBtn) {
      const allChecked = Array.from(checkboxes).every((cb) => cb.checked);
      submitBtn.disabled = !allChecked;
    }
  }

  function addCheckboxListeners() {
    const allCheckboxes = scope.querySelectorAll('.contact__checkbox');
    allCheckboxes.forEach((checkbox) => {
      if (checkbox.dataset.listenerAdded === 'true') return;
      checkbox.dataset.listenerAdded = 'true';
      checkbox.addEventListener('change', function () {
        const form = this.closest('.contact__form');
        checkCheckboxes(form);
      });
    });
  }

  function initSingleFileInput(input) {
    if (!input || input.dataset.fileInitialized === 'true') return;
    input.dataset.fileInitialized = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'contact__file-wrapper';

    const label = document.createElement('label');
    label.className = 'contact__file-label';
    label.innerHTML = `
      <svg class="contact__file-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14,2 14,8 20,8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10,9 9,9 8,9"></polyline>
      </svg>
      <div class="contact__file-text">
        <div>Выберите файл или перетащите сюда</div>
        <div class="contact__file-name" style="display: none;"></div>
      </div>
    `;

    input.parentNode?.insertBefore(wrapper, input.nextSibling);
    wrapper.appendChild(label);
    input.className += ' contact__file-input';

    const id =
      input.id || `file-${Math.random().toString(36).slice(2, 11)}`;
    input.id = id;
    label.setAttribute('for', id);

    input.addEventListener('change', function () {
      const fileName = this.files && this.files[0] ? this.files[0].name : '';
      const nameElement = label.querySelector('.contact__file-name');
      if (!nameElement) return;

      if (fileName) {
        nameElement.textContent = fileName;
        nameElement.style.display = 'block';
        label.style.borderColor = '#d830ae';
        label.style.background = '#f8f0f5';
      } else {
        nameElement.style.display = 'none';
        label.style.borderColor = 'rgba(255, 255, 255, 0.3)';
        label.style.background = '#F6F6F6';
      }
    });

    label.addEventListener('dragover', function (e) {
      e.preventDefault();
      this.style.borderColor = '#d830ae';
      this.style.background = '#f8f0f5';
    });

    label.addEventListener('dragleave', function (e) {
      e.preventDefault();
      this.style.borderColor = 'rgba(255, 255, 255, 0.3)';
      this.style.background = '#F6F6F6';
    });

    label.addEventListener('drop', function (e) {
      e.preventDefault();
      const files = e.dataTransfer?.files;
      if (files && files.length > 0) {
        input.files = files;
        input.dispatchEvent(new Event('change'));
      }
      this.style.borderColor = 'rgba(255, 255, 255, 0.3)';
      this.style.background = '#F6F6F6';
    });
  }

  function initFileInputs() {
    const fileInputs = scope.querySelectorAll(
      'input[type="file"]:not([data-file-initialized="true"])'
    );
    fileInputs.forEach((input) => initSingleFileInput(input));
  }

  addCheckboxListeners();
  initFileInputs();

  setTimeout(() => {
    checkCheckboxes(salesForm);
    checkCheckboxes(partnerForm);
  }, 100);

  const observer = new MutationObserver(() => {
    addCheckboxListeners();
    initFileInputs();
    setTimeout(() => {
      checkCheckboxes(salesForm);
      checkCheckboxes(partnerForm);
    }, 50);
  });

  observer.observe(scope, { childList: true, subtree: true });

  radioBtns.forEach((radio) => {
    radio.addEventListener('change', function () {
      const type = this.value;

      if (type === 'sales') {
        partnerForm.style.opacity = '0';
        partnerForm.style.transform = 'translateY(20px)';

        setTimeout(() => {
          partnerForm.style.display = 'none';
          salesForm.style.display = 'flex';

          setTimeout(() => {
            salesForm.style.opacity = '1';
            salesForm.style.transform = 'translateY(0)';
            setTimeout(() => checkCheckboxes(salesForm), 100);
          }, 50);
        }, 300);
      } else {
        salesForm.style.opacity = '0';
        salesForm.style.transform = 'translateY(20px)';

        setTimeout(() => {
          salesForm.style.display = 'none';
          partnerForm.style.display = 'flex';

          setTimeout(() => {
            partnerForm.style.opacity = '1';
            partnerForm.style.transform = 'translateY(0)';
            setTimeout(() => checkCheckboxes(partnerForm), 100);
          }, 50);
        }, 300);
      }
    });
  });
}

function initContactPopup() {
  const popup = document.getElementById('contact-popup');
  if (!popup) return;

  const openBtns = document.querySelectorAll('[data-open-contact-popup]');
  const presentationOpenBtns = document.querySelectorAll(
    '[data-open-presentation-popup]'
  );
  const closeEls = popup.querySelectorAll('[data-close-contact-popup]');

  const resetPopupForms = () => {
    popup.classList.remove('is-success', 'is-error');

    // Restore visibility of contact wrappers
    const scope = popup.querySelector('[data-contact-scope="popup"]');
    if (scope) {
      // Remove any success/error notice inside scope
      scope.querySelectorAll('.contact-popup__notice').forEach((n) => n.remove());

      const title = scope.querySelector('.contact__form-title');
      if (title) title.style.display = '';
      const radioGroup = scope.querySelector('.contact__radio-group');
      if (radioGroup) radioGroup.style.display = '';

      const salesRadio = scope.querySelector(
        'input.contact__radio[value="sales"]'
      );
      if (salesRadio) salesRadio.checked = true;

      const salesForm = scope.querySelector('.contact__form--sales');
      const partnerForm = scope.querySelector('.contact__form--partner');
      const presentationForm = scope.querySelector(
        '.contact__form--presentation'
      );
      const leadForm = scope.querySelector('.contact__form--lead');

      if (salesForm) {
        salesForm.style.display = 'flex';
        salesForm.style.opacity = '1';
        salesForm.style.transform = 'translateY(0)';
      }
      if (partnerForm) {
        partnerForm.style.display = 'none';
        partnerForm.style.opacity = '0';
        partnerForm.style.transform = 'translateY(20px)';
      }
      if (presentationForm) {
        presentationForm.style.display = 'none';
        presentationForm.style.opacity = '0';
        presentationForm.style.transform = 'translateY(20px)';
      }
      if (leadForm) {
        leadForm.style.display = 'none';
        leadForm.style.opacity = '0';
        leadForm.style.transform = 'translateY(20px)';
      }

      if (title) {
        title.textContent = 'Готовы начать новый проект?';
      }
    }

    // Reset CF7 visual state inside popup so it looks fresh on reopen
    popup.querySelectorAll('.wpcf7').forEach((wrap) => {
      wrap.classList.remove(
        'sent',
        'failed',
        'invalid',
        'spam',
        'unaccepted',
        'aborted',
        'submitting'
      );

      const formEl = wrap.querySelector('form');
      if (formEl) {
        formEl.style.display = '';
      }

      const resp = wrap.querySelector('.wpcf7-response-output');
      if (resp) {
        resp.style.display = 'none';
        resp.textContent = '';
      }
    });
  };

  const showPopupNotice = (message, type = 'success') => {
    const dialog = popup.querySelector('.contact-popup__dialog');
    if (!dialog) return;

    const scope = popup.querySelector('[data-contact-scope="popup"]');
    const host = scope || dialog;

    const existing = host.querySelector('.contact-popup__notice');
    if (existing) existing.remove();

    const notice = document.createElement('div');
    notice.className = `contact-popup__notice contact-popup__notice--${type}`;
    notice.setAttribute('role', 'status');

    if (type === 'success') {
      notice.innerHTML = `
        <div class="contact-popup__notice-icon" aria-hidden="true"></div>
        <div class="contact-popup__notice-content">
          <div class="contact-popup__notice-title">Заявка отправлена</div>
          <div class="contact-popup__notice-text">${message}</div>
        </div>
      `;
    } else {
      notice.innerHTML = `
        <div class="contact-popup__notice-icon contact-popup__notice-icon--error" aria-hidden="true"></div>
        <div class="contact-popup__notice-content">
          <div class="contact-popup__notice-title">Ошибка отправки</div>
          <div class="contact-popup__notice-text">${message}</div>
        </div>
      `;
    }
    host.appendChild(notice);

    window.setTimeout(() => {
      notice.classList.add('is-visible');
    }, 10);

    // In popup we auto-close on success; on error keep notice longer.
    if (type !== 'success') {
      window.setTimeout(() => {
        notice.classList.remove('is-visible');
        window.setTimeout(() => notice.remove(), 200);
      }, 4500);
    }
  };

  let lockedScrollY = 0;
  const lockScroll = () => {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('modal-open');
    document.body.classList.add('modal-open');
    // Prevent background scroll while keeping current visual position
    document.body.style.position = 'fixed';
    document.body.style.top = `-${lockedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  const unlockScroll = () => {
    document.documentElement.classList.remove('modal-open');
    document.body.classList.remove('modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
  };

  const open = () => {
    resetPopupForms();
    popup.hidden = false;
    lockScroll();
    const focusTarget =
      popup.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusTarget?.focus?.();
  };

  const openPresentation = (openerEl) => {
    resetPopupForms();
    popup.hidden = false;
    lockScroll();

    // Root/container used by cf7-redirect.js (presentation detection).
    window.__kmruPresentationRoot = null;

    const scope = popup.querySelector('[data-contact-scope="popup"]');
    window.__kmruPresentationRoot = scope || null;

    // URL файла презентации берём с кнопки "Скачать презентацию" (hero/contact).
    window.__kmruPresentationFileUrl = openerEl?.dataset?.presentationUrl || '';
    window.__kmruPresentationTabOpened = false;
    const title = scope?.querySelector('.contact__form-title');
    const radioGroup = scope?.querySelector('.contact__radio-group');
    const salesForm = scope?.querySelector('.contact__form--sales');
    const partnerForm = scope?.querySelector('.contact__form--partner');
    const presentationForm = scope?.querySelector('.contact__form--presentation');
    const leadForm = scope?.querySelector('.contact__form--lead');

    if (title) title.textContent = 'Скачать презентацию';
    if (radioGroup) radioGroup.style.display = 'none';
    if (salesForm) salesForm.style.display = 'none';
    if (partnerForm) partnerForm.style.display = 'none';
    if (leadForm) leadForm.style.display = 'none';
    if (presentationForm) {
      presentationForm.style.display = 'flex';
      presentationForm.style.opacity = '1';
      presentationForm.style.transform = 'translateY(0)';
    }

    // Флаг для обработчика wpcf7mailsent (чтобы гарантированно понять, что отправили именно презентацию).
    // Также будем использовать форму как источник URL файла.
    const presentationCf7Form =
      presentationForm?.querySelector?.('form') || null;
    window.__kmruPresentationSubmitIntent = {
      openAt: Date.now(),
      formEl: presentationCf7Form,
    };

    const focusTarget =
      popup.querySelector(
        '.contact__form--presentation input, .contact__form--presentation select, .contact__form--presentation textarea, .contact__form--presentation button'
      ) ||
      popup.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
    focusTarget?.focus?.();
  };

  const openLead = () => {
    const scope = popup.querySelector('[data-contact-scope="popup"]');
    const leadForm = scope?.querySelector('.contact__form--lead');
    if (!leadForm) return;

    resetPopupForms();
    popup.hidden = false;
    lockScroll();

    const title = scope?.querySelector('.contact__form-title');
    const radioGroup = scope?.querySelector('.contact__radio-group');
    const salesForm = scope?.querySelector('.contact__form--sales');
    const partnerForm = scope?.querySelector('.contact__form--partner');
    const presentationForm = scope?.querySelector(
      '.contact__form--presentation'
    );

    if (title) title.textContent = 'Оставить заявку';
    if (radioGroup) radioGroup.style.display = 'none';
    if (salesForm) salesForm.style.display = 'none';
    if (partnerForm) partnerForm.style.display = 'none';
    if (presentationForm) presentationForm.style.display = 'none';

    leadForm.style.display = 'flex';
    leadForm.style.opacity = '1';
    leadForm.style.transform = 'translateY(0)';

    const focusTarget =
      leadForm.querySelector(
        'input, select, textarea, button'
      ) ||
      popup.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
    focusTarget?.focus?.();
  };

  const isFormLeadHref = (href) => {
    if (!href) return false;
    try {
      // Абсолютные и относительные: "#form-lead", "/page#form-lead", "https://site/#form-lead"
      const url = new URL(href, window.location.origin);
      return url.hash === '#form-lead';
    } catch (_) {
      return href === '#form-lead' || href.endsWith('#form-lead');
    }
  };

  const close = () => {
    popup.hidden = true;
    window.__kmruPresentationTabOpened = false;
    unlockScroll();
  };

  openBtns.forEach((btn) => btn.addEventListener('click', open));
  presentationOpenBtns.forEach((btn) =>
    btn.addEventListener('click', (e) => {
      // Кнопка обычно href="#", чтобы не уходить со страницы.
      e.preventDefault();
      openPresentation(e.currentTarget);
    })
  );

  // Любые ACF/хедер-кнопки со ссылкой #form-lead открывают форму заявки.
  document.addEventListener('click', (e) => {
    const link = e.target?.closest?.('a[href]');
    if (!link) return;
    if (!isFormLeadHref(link.getAttribute('href'))) return;
    e.preventDefault();
    openLead();
  });

  // PDF открываем только после успешной отправки CF7 (wpcf7mailsent),
  // чтобы не срабатывало при проваленной валидации.
  closeEls.forEach((el) => el.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (!popup.hidden && e.key === 'Escape') close();
  });

  // Init scoped forms (page + popup) once DOM is ready
  const pageScope = document.querySelector('.contact__form-wrapper#contact');
  if (pageScope) initContactScope(pageScope);

  const popupScope = popup.querySelector('[data-contact-scope="popup"]');
  if (popupScope) initContactScope(popupScope);

  // CF7 success handler: show notice and close popup after a moment
  document.addEventListener('wpcf7mailsent', (event) => {
    try {
      const target = event?.target;
      if (!target) return;
      // Only react for forms inside this popup
      if (!popup.contains(target)) return;

      // Hide CF7 default response and the submitted form in popup
      const wpcf7Wrap = target.closest('.wpcf7') || popup.querySelector('.wpcf7');
      const resp = wpcf7Wrap?.querySelector?.('.wpcf7-response-output');
      if (resp) resp.style.display = 'none';

      const cf7FormEl = wpcf7Wrap?.querySelector?.('form');
      if (cf7FormEl) cf7FormEl.style.display = 'none';

      const sentPresentation = !!wpcf7Wrap?.closest(
        '.contact__form--presentation'
      );
      const sentLead = !!wpcf7Wrap?.closest('.contact__form--lead');

      // Also hide active wrapper so only notice remains
      const popupScope = popup.querySelector('[data-contact-scope="popup"]');
      const title = popupScope?.querySelector?.('.contact__form-title');
      if (title) title.style.display = 'none';
      const radioGroup = popupScope?.querySelector?.('.contact__radio-group');
      if (radioGroup) radioGroup.style.display = 'none';

      popup.classList.remove('is-error');
      popup.classList.add('is-success');

      if (sentPresentation) {
        const presentationForm =
          popupScope?.querySelector?.('.contact__form--presentation');
        if (presentationForm) presentationForm.style.display = 'none';
        showPopupNotice('Презентация отправлена.', 'success');
        // Даём пользователю время прочитать уведомление.
        window.setTimeout(() => {
          // Открываем PDF/презентацию, указанную в админке на кнопке.
          const url = window.__kmruPresentationFileUrl;
          if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            // eslint-disable-next-line no-console
            console.warn(
              '[kmru] presentation url missing on success (delayed)'
            );
          }
        }, 1200);
      } else if (sentLead) {
        const leadForm = popupScope?.querySelector?.('.contact__form--lead');
        if (leadForm) leadForm.style.display = 'none';
        showPopupNotice(
          'Спасибо! Мы свяжемся с вами в ближайшее время.',
          'success'
        );
      } else {
        const activeRadio =
          popup.querySelector(
            '[data-contact-scope="popup"] input.contact__radio:checked'
          );
        const activeValue = activeRadio?.value;
        const activeBlock =
          activeValue === 'partner'
            ? popup.querySelector(
                '[data-contact-scope="popup"] .contact__form--partner'
              )
            : popup.querySelector(
                '[data-contact-scope="popup"] .contact__form--sales'
              );
        if (activeBlock) activeBlock.style.display = 'none';
        showPopupNotice(
          'Спасибо! Мы свяжемся с вами в ближайшее время.',
          'success'
        );
      }

      window.setTimeout(() => {
        // Close only if still open
        if (!popup.hidden) close();
      }, 2200);
    } catch (_) {
      // no-op
    }
  });

  // Optional: show error notice on failed send
  document.addEventListener('wpcf7mailfailed', (event) => {
    const target = event?.target;
    if (!target) return;
    if (!popup.contains(target)) return;
    popup.classList.remove('is-success');
    popup.classList.add('is-error');
    showPopupNotice('Не удалось отправить. Попробуйте ещё раз.', 'error');
  });
}

function initContactFabPosition() {
  const fab = document.querySelector('.contact-fab');
  const slot = document.querySelector('.contact-fab-slot');
  const footerBottom = document.querySelector('.footer__bottom');

  if (!fab || !slot || !footerBottom) return;

  const narrowViewport = window.matchMedia('(max-width: 1823px)');

  const getMargin = () =>
    window.matchMedia('(max-width: 768px)').matches ? 16 : 24;

  let ticking = false;

  const update = () => {
    const margin = getMargin();
    const fabHeight = fab.offsetHeight;
    const pinLine = window.innerHeight - margin;
    const pinTargetRect = narrowViewport.matches
      ? footerBottom.getBoundingClientRect()
      : slot.getBoundingClientRect();
    const stopTop = pinTargetRect.top;
    const gap = narrowViewport.matches ? 8 : 0;

    if (stopTop <= pinLine) {
      fab.style.position = 'fixed';
      fab.style.top = `${stopTop - fabHeight - gap}px`;
      fab.style.bottom = 'auto';
      fab.style.right = `${margin}px`;
      fab.style.left = 'auto';
    } else {
      fab.style.position = '';
      fab.style.top = '';
      fab.style.bottom = '';
      fab.style.right = '';
      fab.style.left = '';
    }

    ticking = false;
  };

  const scheduleUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  scheduleUpdate();
}

export function initContactPopupModule() {
  initContactPopup();
  initContactFabPosition();
}

